export default {
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setTwoFaStatus(state, payload) {
    state.isTwoFaEnabled = payload;
  },
  setQrCode(state, payload) {
    state.qrCodeDataUrl = payload;
  },
  setSecretKey(state, payload) {
    state.secretKey = payload;
  },
  setMessage(state, payload) {
    state.message = payload;
  },
  resetQrData(state) {
    state.qrCodeDataUrl = "";
    state.secretKey = "";
  },
};
